/* eslint-disable */
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"
import { clFarmGuardAbi } from "@/domains/abis"

import type { TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type StakeLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  guardAddress: Address
  ichiTokenAddress: Address
  mintToken0Address: Address
  vdepAddress: Address
  amount: bigint
}

export const mintIchiClFarmLiquidity = async ({
  account,
  chainId,
  config,
  guardAddress,
  ichiTokenAddress,
  mintToken0Address,
  vdepAddress,
  amount,
}: StakeLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: clFarmGuardAbi as Abi,
        account,
        chainId,
        address: guardAddress,
        args: [ichiTokenAddress, vdepAddress, mintToken0Address, amount, 1, account],
        functionName: "forwardDepositToICHIVault",
      },
    })
    return result
  } catch (error: any) {
    console.error("mintIchiClFarmLiquidity", error)
    return { success: false, error: error.message, code: error.code }
  }
}
